<template>
  <div>
    <el-input
      v-model="value"
      type="textarea"
      :rows="8"
      @update:modelValue="update"
    />
    <p class="hint">
      Supports human-readable ip ranges (1.1.1.1-2.2.2.2) or with subnet mask
      (1.1.1.1/24, 2001:4860:4860::8890/124). One per line.
    </p>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue'

export default defineComponent({
  name: 'IpListEditor',
  props: {
    modelValue: {
      type: String,
      required: true
    }
  },
  setup(props, context) {
    const value = ref(props.modelValue)
    const update = (newValue: string) => {
      context.emit('update:modelValue', newValue)
    }

    watch(
      (_: any) => props.modelValue,
      (val: any) => {
        value.value = val
      }
    )
    return { update, value }
  }
})
</script>

<style lang="scss" scoped>
.hint {
  line-height: 1.2;
  color: var(--el-text-color-secondary);
}
</style>
